// extracted by mini-css-extract-plugin
export var cardNumber = "crewRising-module--cardNumber--c9b41";
export var content = "crewRising-module--content--12fa8";
export var copy = "crewRising-module--copy--f7bc8";
export var crewRising = "crewRising-module--crew-rising--57acc";
export var eyebrow = "crewRising-module--eyebrow--00c98";
export var image = "crewRising-module--image--e7789";
export var mobile = "crewRising-module--mobile--eab20";
export var position = "crewRising-module--position--74966";
export var positionWrapper = "crewRising-module--position-wrapper--e1319";
export var positions = "crewRising-module--positions--7d531";
export var stepArrow = "crewRising-module--step-arrow--c51d3";
export var web = "crewRising-module--web--fb7b5";